import { Position, State } from 'src/types'
import { catchFace } from 'src/features/dxm/drawer/rightThrow/glove/front/catchFace'
import { edges } from 'src/features/dxm/drawer/rightThrow/glove/front/edge'
import { hamidashi } from 'src/features/dxm/drawer/rightThrow/glove/front/hamidashi'
import { listLining } from 'src/features/dxm/drawer/rightThrow/glove/front/listLining'
import { lace } from 'src/features/dxm/drawer/rightThrow/glove/front/lace'
import { thumbBackOut, thumbBackWebSide } from 'src/features/dxm/drawer/rightThrow/glove/front/back/thumbFinger'
import { indexBackMiddleSide, indexBackWebSide } from 'src/features/dxm/drawer/rightThrow/glove/front/back/indexFinger'
import { middleBackIndexSide, middleBackRingSide } from 'src/features/dxm/drawer/rightThrow/glove/front/back/middleFinger'
import { ringBackLittleSide } from 'src/features/dxm/drawer/rightThrow/glove/front/back/ringFinger'
import { littleBackOut, littleBackRingSide } from 'src/features/dxm/drawer/rightThrow/glove/front/back/littleFinger'
import { backLaceDrawerOfFront } from 'src/features/dxm/drawer/common/useCanvasHelper'
import { laceOfUnderWebDrawer } from 'src/features/dxm/drawer/rightThrow/glove/front/web/useCanvasWebFront'
import { canvasResetter } from 'src/util/canvas'
import { rightLaceOfNetWebDrawer, webOfGloveFrontDrawer } from 'src/features/dxm/drawer/rightThrow/glove/front/web/useCanvasWebFront'
import { dxmEngravedOfCatchFace } from 'src/features/dxm/drawer/rightThrow/glove/back/label'

export const dxmCanvasGloveFront = (ctx: CanvasRenderingContext2D, state: State, position: Position): void => {
  // リセット
  canvasResetter(ctx)
  // 裏革
  listLining(ctx, state.listLiningsMaterial?.color)
  // 背面の紐
  backLaceDrawerOfFront(ctx, state.backLace?.value, state.lace?.color, position)
  // ウェブの描画
  webOfGloveFrontDrawer(ctx, state)
  // 捕球面
  catchFace(ctx, state.catchFace?.color)
  // 親指背面＿外側
  thumbBackOut(ctx, state.thumbOut?.color)
  // 親指背面＿ウェブ側
  const thumbBackWebSideColor = state.thumbWeb?.value === 'unselected' ? state.thumbWebAndIndexWeb?.color : state.thumbWeb?.color
  thumbBackWebSide(ctx, thumbBackWebSideColor)
  // 人差し指背面＿ウェブ側
  indexBackWebSide(ctx, state?.indexWeb?.color)
  // 人差し指背面＿中指側
  indexBackMiddleSide(ctx, state.hamidashiCut.value === 'hamidashiCut' ? state?.indexWeb?.color : state?.indexMiddle?.color)
  // 中指背面＿人差し指側
  middleBackIndexSide(ctx, state?.middleIndex?.color)
  // 中指背面＿薬指側
  middleBackRingSide(ctx, state?.middleRing?.color)
  // 薬指背面＿小指側
  ringBackLittleSide(ctx, state?.ringLittle?.color)
  // 小指背面＿薬指側
  littleBackRingSide(ctx, state?.littleRing?.color)
  // 小指背面＿外側
  littleBackOut(ctx, state.littleOut?.color)
  // ハミダシ
  hamidashi(ctx, state.hamidashi?.color)
  // ヘリ革
  edges(ctx, state.edge?.color, state.lace?.color, state.stitch?.color, position, state?.bankLaceDirection)
  // ネットウェブのみの革紐
  rightLaceOfNetWebDrawer(ctx, state)
  // 革紐
  lace(ctx, state.lace?.color, state?.materialPack, position)
  // ウェブ下の革紐
  laceOfUnderWebDrawer(ctx, state)
  // メーカー捕球面の刻印
  dxmEngravedOfCatchFace(ctx, state.catchFace, 0, 0)
}
